export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      reservedNotices: [
        {
          noticeId: 3,
          noticeUuid: "notice003",
          reservedDeliveryAt: 1234567890123,
          deliveryType: "signage",
          deliveryTypeName: "サイネージ",
          noticeType: "opinionaire",
          noticeTypeName: "アンケート",
          deliveryToKbn: 0,
          reservedNoticeStatus: 1,
          noticeContents: "地元の名産品について",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeId: 2,
          noticeUuid: "notice002",
          reservedDeliveryAt: 1234567890123,
          deliveryType: "normal",
          deliveryTypeName: "お知らせ",
          noticeType: "sound_broadcast",
          noticeTypeName: "音声定時放送",
          deliveryToKbn: 1,
          reservedNoticeStatus: 1,
          noticeContents: "音声定時放送",
          noticeSenderName: "アイラ地域サポート",
        },
        {
          noticeId: 1,
          noticeUuid: "notice001",
          reservedDeliveryAt: 1234567890123,
          deliveryType: "normal",
          deliveryTypeName: "お知らせ",
          noticeType: "text",
          noticeTypeName: "テキストのみ",
          deliveryToKbn: 2,
          reservedNoticeStatus: 1,
          noticeContents: "〇〇大会延期のお知らせ",
          noticeSenderName: "アイラ地域サポート",
        }
      ]
    }
  }
}